import { create } from "zustand";

interface UserProfileSlice {
    avatar: string | undefined;
    privacySettings: {
        showProfilePicture: boolean | undefined;
    };
    screenName: string;
    uuid: string;
    gender?: string;
}

interface UserProfileStore {
    reset: () => void;
    setShowUserAvatar: (showUserAvatar: boolean) => void;
    setUserProfile: (value: UserProfileSlice) => void;
    showUserAvatar: boolean;
    userProfile: UserProfileSlice;
}

export const useUserProfileStore = create<UserProfileStore>()((set) => ({
    userProfile: {} as UserProfileSlice,
    showUserAvatar: false,
    setShowUserAvatar: (showUserAvatar) => set({ showUserAvatar }),
    setUserProfile: (userProfile: UserProfileSlice) => {
        set({ showUserAvatar: true });
        set({ userProfile });
    },
    reset: () =>
        set({
            userProfile: {} as UserProfileSlice,
        }),
}));

export const useUserProfile = (): UserProfileSlice => {
    return (
        useUserProfileStore((state) => state.userProfile) ?? {
            avatar: "",
            uuid: "",
            screenName: "",
            gender: "",
        }
    );
};
